import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LOCK_ICON } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { LockedCustomerIcon as LockedCustomerIconUnified } from './LockedCustomerIcon'
import { LockedCustomerIconLegacy } from './LockedCustomerIconLegacy'

export const LockedCustomerIcon: React.FC = () => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LOCK_ICON
  )

  return isUnifiedEnabled ? (
    <LockedCustomerIconUnified />
  ) : (
    <LockedCustomerIconLegacy />
  )
}
